import { c as _c } from "react/compiler-runtime";
import { FormInput, PaymentProcessorEnum, PrimaryButton, getPaymentProcessorTitle, useTranslation as useUiTranslation } from '@systemeio/ui';
import HelpCenterLink from 'modules/profile/payment-gateways/components/help-center-link';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { flutterwaveConnect } from 'modules/profile/payment-gateways/integrations/flutterwave/api';
import { PaymentFlutterwaveInterface } from 'modules/profile/payment-gateways/integrations/flutterwave/types';
import { getFlutterwaveHelpPageLink } from 'modules/profile/payment-gateways/integrations/flutterwave/utils';
import React, { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
interface FlutterwaveCreateModalProps {}
const defaultValues: PaymentFlutterwaveInterface = {
  apiEncryptionKey: '',
  apiKeySecret: '',
  apiPublicKey: ''
};
const defaultErrors: PaymentFlutterwaveInterface = {
  apiEncryptionKey: '',
  apiPublicKey: '',
  apiKeySecret: ''
};
const FlutterwaveCreateModal = t0 => {
  const $ = _c(41);
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const {
    user
  } = useUser();
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  const {
    mutatePaymentIntegrations
  } = useConnectedPaymentIntegrations();
  let t1;
  if ($[0] !== mutatePaymentIntegrations) {
    t1 = async data => {
      await fetchWithErrors(async () => {
        await flutterwaveConnect(data);
        await mutatePaymentIntegrations();
      }, setErrors);
    };
    $[0] = mutatePaymentIntegrations;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onCreate = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      e.preventDefault();
      setOpened(true);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("dashboard.settings.payment_gateways.connect");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <PrimaryButton onClick={t2} className="font-bold">{t3}</PrimaryButton>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t || $[8] !== tUi) {
    t5 = t("dashboard.settings.payment_gateways.connect_payment_title", {
      payment: getPaymentProcessorTitle(PaymentProcessorEnum.Flutterwave, tUi)
    });
    $[7] = t;
    $[8] = tUi;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setOpened(false);
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== errors || $[12] !== t) {
    t7 = {
      field: "apiPublicKey",
      onRender: (value, onChange) => <FormInput key="flutterwave-apiPublicKey-create" label={t("dashboard.settings.payment-gateways.api_public_key")} value={value} onChange={e_0 => onChange(e_0.target.value)} error={errors.apiPublicKey} />
    };
    $[11] = errors;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== errors || $[15] !== t) {
    t8 = {
      field: "apiKeySecret",
      onRender: (value_0, onChange_0) => <FormInput key="flutterwave-apiKeySecret-create" label={t("dashboard.settings.payment-gateways.api_secret_key")} value={value_0} onChange={e_1 => onChange_0(e_1.target.value)} error={errors.apiKeySecret} />
    };
    $[14] = errors;
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== errors || $[18] !== t) {
    t9 = {
      field: "apiEncryptionKey",
      onRender: (value_1, onChange_1) => <FormInput key="flutterwave-apiEncryptionKey-create" label={t("dashboard.settings.payment-gateways.api_encryption_key")} value={value_1} onChange={e_2 => onChange_1(e_2.target.value)} error={errors.apiEncryptionKey} />
    };
    $[17] = errors;
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t10 = [t7, t8, t9];
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const t11 = user?.dashboardLocale;
  let t12;
  if ($[24] !== t11) {
    t12 = getFlutterwaveHelpPageLink(t11);
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== tUi) {
    t13 = getPaymentProcessorTitle(PaymentProcessorEnum.Flutterwave, tUi);
    $[26] = tUi;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12 || $[29] !== t13) {
    t14 = <HelpCenterLink link={t12} integration={t13} />;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = ["apiEncryptionKey", "apiKeySecret", "apiPublicKey"];
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== onCreate || $[33] !== opened || $[34] !== t10 || $[35] !== t14 || $[36] !== t5) {
    t16 = <CreateModal fullCaption={t5} opened={opened} onClose={t6} defaultValues={defaultValues} needToast={false} creatable={t10} additionalInfo={t14} onCreate={onCreate} requiredFields={t15} />;
    $[32] = onCreate;
    $[33] = opened;
    $[34] = t10;
    $[35] = t14;
    $[36] = t5;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t16 || $[39] !== t4) {
    t17 = <>{t4}{t16}</>;
    $[38] = t16;
    $[39] = t4;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  return t17;
};
export default FlutterwaveCreateModal;